import { render } from "./message.vue?vue&type=template&id=393b826c&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=393b826c&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393b826c"]])

export default __exports__